import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { message, Space, Table } from "antd";
import { renderCheckbox } from "@extensions/helper";

const CompanyConditions = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState();

  const getData = () => {
    setLoading(true);
    serverFetch(`condition`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const columns = [
    { dataIndex: "id", title: "#" },
    { dataIndex: "idDb", title: "База" },
    { dataIndex: "isAct", title: "Акт.", render: renderCheckbox },
    { dataIndex: "name", title: "Наименование" },
    { dataIndex: "vid", title: "Вид" },
    { dataIndex: "filterCompany", title: "Отправитель" },
    { dataIndex: "filterIdDb", title: "База" },
    { dataIndex: "filterIdDepno", title: "Отдел" },
    { dataIndex: "modCompany", title: "Получатель" },
    { dataIndex: "modIdDb", title: "База" },
    { dataIndex: "modIdDepno", title: "Отдел" },
    { dataIndex: "modAccept", title: "Разрешить", render: renderCheckbox },
  ]
  
  return <div>
    <Table 
      dataSource={items}
      loading={loading}
      columns={columns}
      pagination={false}
      size="small"
      rowKey="id"
      rowSelection={{ type: 'radio', selectedRowKeys: [selected], renderCell: checked => <div className={checked ? "misoft-list-indicator" : ""} /> }}
      onRow={(record) => ({onClick: () => { setSelected(record.id) }})}
      />
    {/* {selected && <CompanyBase onClose={onCloseEdit} id={selected} />} */}
  </div>
}

export default CompanyConditions;
